export default "__VITE_ASSET__CedHlh$d__"